// const host = "https://inventory-api.lamha-iq.com/";
// const host = "https://api.lamha-iq.com/";
// const host = "https://api.enfirad.com/";

 const host = "https://hayder.api.enfirad.com/";
// const host = "https://bs2.api.enfirad.com/";

export default host;